import React from 'react'
import { Control, Controller, FieldError } from 'react-hook-form'
import { MaskedInput } from '../atoms'

interface EINFieldProps {
  id: string
  name: string
  defaultValue: string
  placeholder: string
  isRequired?: boolean
  error?: FieldError
  control: Control<any, any>
}

const EINField: React.FC<EINFieldProps> = ({
  id,
  name,
  defaultValue,
  placeholder,
  isRequired,
  error,
  control,
}) => (
  <Controller
    control={control}
    name={name}
    defaultValue={defaultValue}
    rules={{
      validate: {
        einRequired: value => {
          return isRequired && value.trim().length < 10
            ? '9 digits required'
            : undefined
        },
      },
    }}
    render={({ field: { onChange, onBlur, value } }) => (
      <MaskedInput
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        name={name}
        id={id}
        type='text'
        format='##-#######'
        placeholder={placeholder}
        bordercolor={error && 'error'}
      />
    )}
  />
)

export default EINField
